import {
  IonCol,
  IonGrid,
  IonItem,
  IonList,
  IonRow,
  IonBadge,
} from "@ionic/react";
import React from "react";

import { ICommentNotification, IConversationNotification } from "../../state";
import { simpleDateTimeStr } from "../../libs/Util";
import { realizationDetailPath } from "../../store/student";

import styles from "./CommentNotifications.module.scss";

export interface CommentNotificationsProps {
  commentNotifications: ICommentNotification[];
  conversationNotifications?: IConversationNotification[];
}

const CommentNotifications: React.FC<CommentNotificationsProps> = ({
  commentNotifications,
  conversationNotifications = [],
}) => {
  const allNotifications = [
    ...commentNotifications.map(notification => ({
      type: "comment" as const,
      ...notification,
    })),
    ...conversationNotifications.map(notification => ({
      type: "conversation" as const,
      ...notification,
    })),
  ].sort((a, b) => b.created_at.getTime() - a.created_at.getTime());

  return (
    <div className={styles.wrapper}>
      <IonList className={styles.wrapper}>
        {allNotifications.length ? (
          allNotifications.map((notification, index) => {
            const { unread_count, content, created_at, realization, type } =
              notification;

            const commentor_name =
              type === "comment"
                ? (notification as typeof notification & { type: "comment" })
                    .commentor_name
                : null;

            return (
              <IonItem
                key={`${type}-${index}`}
                routerLink={`${realizationDetailPath}/${realization.id}`}
                className={styles.item}
              >
                <IonGrid className={styles.grid}>
                  <IonRow>
                    <IonCol size="12">
                      <div className={styles.content}>
                        <span>
                          {type === "comment"
                            ? commentor_name
                              ? `${commentor_name} さんがコメントしました`
                              : "コメントが追加されました"
                            : "GEARから返信がきています"}
                        </span>
                        {unread_count > 1 && (
                          <IonBadge color="danger">
                            他{unread_count - 1}件
                          </IonBadge>
                        )}
                      </div>
                    </IonCol>
                    <IonCol size="12">
                      <div className={styles.footer}>
                        <span>{content}</span>
                        <span>{simpleDateTimeStr(created_at)}</span>
                      </div>
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </IonItem>
            );
          })
        ) : (
          <p className={styles.emptyData}>コメント通知はありません。</p>
        )}
      </IonList>
    </div>
  );
};

export default CommentNotifications;
